import { BigNumber } from 'ethers'
import { StaticJsonRpcProvider } from '@ethersproject/providers'
import { parseUnits } from 'ethers/lib/utils'

import { getNerveContract } from '~/contracts/getNerveContract'
import { getPoolLiquidityContract } from '~/contracts/getPoolLiquidityContract'

import { LP_TOKEN_DECIMALS } from './constants'

interface Params {
	account: string
	poolAddress: string
	provider: StaticJsonRpcProvider
}

export async function getPoolBalance({
	account,
	poolAddress,
	provider,
}: Params): Promise<BigNumber> {
	try {
		const nerveContract = getNerveContract(poolAddress, provider)

		const { lpToken } = await nerveContract.swapStorage()

		const poolLiquidityContract = getPoolLiquidityContract(
			lpToken,
			provider
		)

		const virtualPrice: BigNumber = await nerveContract.getVirtualPrice()

		const lpTokenBalance: BigNumber = await poolLiquidityContract.balanceOf(
			account
		)

		return virtualPrice
			.mul(lpTokenBalance)
			.div(parseUnits('1.0', LP_TOKEN_DECIMALS))
	} catch (error) {
		throw new Error('getPoolBalance failed')
	}
}
